import React, { useContext, useMemo } from 'react';
import { DataGrid, GridColDef } from '@fashionnovateam/nova-ui-toolkit';
import { FeatureFlagsContext } from '../../Lib/Contexts/FeatureFlagsContext';
import Header from '../Header';
import Page from '../Page';

function FeatureFlags(): React.JSX.Element {
  const { flags } = useContext(FeatureFlagsContext);

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Feature Flag',
      render: 'string',
      flex: 1,
      sortable: true,
      minWidth: 200,
      disableColumnMenu: true,
      display: 'flex',
    },
    {
      field: 'status',
      headerName: 'Status',
      render: 'badge',
      flex: 1,
      sortable: true,
      minWidth: 150,
      disableColumnMenu: true,
      display: 'flex',
    },
  ];

  const transformedRows = useMemo(
    () =>
      Object.entries(flags).map(([flagName, flag]) => ({
        id: flagName,
        name: flagName,
        status: {
          children: flag.enabled ? 'Enabled' : 'Disabled',
          color: flag.enabled ? 'green' : 'red',
          contrast: 'low',
        },
      })),
    [flags],
  );

  return (
    <Page.Container>
      <Header.Major icon="flag" title="Feature Flags" />
      <Page.Content>
        <DataGrid
          stateName="feature_flags_datagrid"
          hideFilterButton
          hideGroupButton
          columns={columns}
          rows={transformedRows}
          initialState={{
            pinnedColumns: {
              left: ['name'],
            },
          }}
          sortingMode="client"
          paginationMode="client"
          pageSizeOptions={[15]}
        />
      </Page.Content>
    </Page.Container>
  );
}

export default FeatureFlags;
